import './bootstrap';
import axios from 'axios';
import Vue from 'vue';
import vuetify from './plugins/vuetify'; // path to vuetify export
import router from './router';
import store from './store';
import mixin  from './mixins/mixin';

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import underscore from 'vue-underscore';
Vue.use(underscore);

import ElementUI from 'element-ui';
import { ElementTiptapPlugin } from 'element-tiptap';
// import ElementUI's styles
import 'element-ui/lib/theme-chalk/index.css';
// import this package's styles
import 'element-tiptap/lib/index.css';

// use ElementUI's plugin
Vue.use(ElementUI);
// use this package's plugin
Vue.use(ElementTiptapPlugin, {
	/* plugin options */
	lang: "en", // see i18n
	spellcheck: true, // can be overwritten by editor prop
});
// Now you register `'el-tiptap'` component globally.

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import VuePapaParse from 'vue-papa-parse';
Vue.use(VuePapaParse);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components/', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// global mixin
Vue.mixin(mixin);

axios.interceptors.response.use(
	response => {
		return response;
	},
	async error => {
		// se ho impostato manualmente nell'oggetto config di richiesta axios la proprietà dontShowSystemSnackbar: true
		// restituisco l'errore ma non mostro la systemSnackbar
		if (error.config && error.config.dontShowSystemSnackbar) {
			// Lascia che l'errore venga gestito localmente
			return Promise.reject(error);
		}
		
		// console.log(error.response.status);
		const status = error.response.status;
		
		if ((status === 401 || status === 419) && !window.location.pathname.includes('/login')) {
			// console.log("THIS IS THE 401/419 INTERCEPTOR")
			// return store.dispatch('auth/me')
			return store.dispatch('auth/resetMe')
				.then(() => {
					router.replace({ name: 'login' });
				})
				.then(() => Promise.reject(error))   // <-- mantiene la semantica di errore
		}
		else if (status === 500) {
			await store.dispatch('systemSnackbar/show', {
				color: 'error',
				message: 'Errore del Server'
			})
			
			return Promise.reject(error);
		}
		else {
			// TODO: salvare log sul database ('admin', error.message)
			
			const errorMessage = error.response.data.message === ''
			|| error.response.data.message === null
				? 'Errore'
				: error.response.data.message;
			
			// console.log(errorMessage);
			
			await store.dispatch('systemSnackbar/show', {
				color: 'error',
				message: errorMessage
			})
			
			return Promise.reject(error);
		}
	}
);

const vueSetUp = {
	store,
	vuetify,
	router
};

// https://chatgpt.com/c/6845feae-3894-8009-b44f-b6662e4250f2
;(async () => { // IL PUNTO E VIRGOLA SERVE
	try {
		await store.dispatch('auth/me')
		
		if (store.getters['auth/isAuthenticated'] && store.getters['auth/isAccountManager']) {
			await store.dispatch('shared/ottieniImpostazioniAm')
				.catch(e => {                 // intercetta il 401 locale
					console.warn('Impostazioni AM non caricate:', e.message);
				})
		}
	}
	finally {
		// Monta sempre l'app: se non autenticato, l'interceptor fa login
		new Vue(vueSetUp).$mount('#app-laravel');
		// new Vue({ store, vuetify, router }).$mount('#app-laravel');
	}
})()

// store.dispatch('auth/me')
// 	.then(() => {
// 		if (store.getters['auth/isAccountManager']) {
// 			return store.dispatch('shared/ottieniImpostazioniAm');
// 		}
// 	})
// 	.then(() => {
// 		axios.interceptors.response.use(
// 			response => {
// 				return response;
// 			},
// 			async error => {
// 				// se ho impostato manualmente nell'oggetto config di richiesta axios la proprietà dontShowSystemSnackbar: true
// 				// restituisco l'errore ma non mostro la systemSnackbar
// 				if (error.config && error.config.dontShowSystemSnackbar) {
// 					// Lascia che l'errore venga gestito localmente
// 					return Promise.reject(error);
// 				}
//
// 				console.log(error.response.status);
// 				const status = error.response.status;
//
// 				if((status === 401 || status === 419) && !window.location.pathname.includes('/login')) {
// 					// console.log("THIS IS THE 401/419 INTERCEPTOR")
// 					return store.dispatch('auth/me')
// 						.then(() => {
// 							router.replace({ name: 'login' })
// 						})
// 				}
// 				else if (status === 500) {
// 					await store.dispatch('systemSnackbar/show', {
// 						color: 'error',
// 						message: 'Errore del Server'
// 					})
//
// 					return Promise.reject(error);
// 				}
// 				else {
// 					// TODO: salvare log sul database ('admin', error.message)
//
// 					const errorMessage = error.response.data.message === ''
// 						|| error.response.data.message === null
// 						? 'Errore'
// 						: error.response.data.message;
//
// 					console.log(errorMessage);
//
// 					await store.dispatch('systemSnackbar/show', {
// 						color: 'error',
// 						message: errorMessage
// 					})
//
// 					return Promise.reject(error);
// 				}
// 			}
// 		);
// 	})
// 	.finally(() => {
// 		new Vue(vueSetUp).$mount('#app-laravel');
// 	});
